import React from 'react'

import { djb2Hex } from 'src/utils/djb2'

const RadioList = ({
  legend, horizontal, id, options, name, value, onChange, inline,
  columns = [ 'col-sm-3', 'col-sm-9' ],
  wrapperClass = horizontal ? 'mb-3 row' : 'mb-3',
  legendClass = horizontal ? `form-label col-form-label ${columns[0]}` : 'form-label float-none w-auto fs-6',
  optionsClass = horizontal ? `col-form-label ${columns[1]}` : null,
  optionClass = [ 'form-check', inline && 'form-check-inline' ].filter(Boolean).join(' '),
  inputClass = 'form-check-input',
  labelClass = 'form-check-label',
}) =>
  <fieldset className={`${wrapperClass} row-${id}`}>
    {
      legend &&
      <legend className={legendClass}>
        {legend}
      </legend>
    }

    <div className={optionsClass}>
      {options.map(({ label, hint, ...option }, i) => {
        const itemID = [ id, djb2Hex(option.value || i) ].join('-')
        return (
          <div key={option.value || i} className={optionClass}>
            <input
              type="radio"
              id={itemID}
              name={name || id}
              className={inputClass}
              {...option}
              checked={value == option.value}
              onChange={e => onChange({
                ...e, target: { ...e.target, value: option.value }
              })}
            />
            <label className={labelClass} htmlFor={itemID}>{label}</label>
            {hint && <div className="form-text">{hint}</div>}
          </div>
        )
      })}
    </div>
  </fieldset>

export default RadioList
